import React from "react";
import { useAuth } from "./AuthContext";
import { Text } from "@chakra-ui/react";
import { isAllowedToView, isModuleAvailable } from "utils/AuthUtils";

/**
 * TODO document this: where are the permissions and modules defined? refer to key files.
 *
 * This links up with module= settings in paths.js
 */
function WithAuthorization(Component) {
  return function WithAuthorizationComponent({ componentRequiredPermissions, module, ...props }) {
    const { userPermissions } = useAuth();

    if (isAllowedToView(userPermissions, componentRequiredPermissions) && isModuleAvailable(module)) {
      return <Component {...props} />;
    } else {
      return <Text p={4}>{"Authorised login required"}</Text>;
    }
  };
}

export default WithAuthorization;
